import {
    IConfirmationDialogInput,
    IConfirmationDialogOutput,
    IConfirmationRejectionReasonDialogOutput
} from '../types/confirmation.type';
import {Injectable} from '@angular/core';
import {MatDialog} from '@angular/material';
import {map} from 'rxjs/operators';
import {ConfirmationDialogComponent} from '../components/confirmation-dialog/confirmation-dialog.component';
import {RejectionReasonDialogComponent} from '../components/rejection-reason-dialog/rejection-reason-dialog.component';

@Injectable()

export class ConfirmationService {

    constructor(private dialog: MatDialog) {
    }

    openDialog(data: IConfirmationDialogInput): Promise<IConfirmationDialogOutput> {
        const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
            width: data.dialogWidth ? data.dialogWidth : '300px',
            data,
            disableClose: true,
        });

        return dialogRef
            .afterClosed()
            .pipe(map(result => {
                return result;
            }))
            .toPromise()
            .catch();

    }


    openRejectionReasonDialog(data: IConfirmationDialogInput): Promise<IConfirmationRejectionReasonDialogOutput> {
        const dialogRef = this.dialog.open(RejectionReasonDialogComponent, {
            width: '400px',
            data,
            disableClose: true,
        });

        return dialogRef
            .afterClosed()
            .pipe(map(result => {
                return result;
            }))
            .toPromise()
            .catch();

    }
}
